export default __webpack_public_path__ + "static/media/login-pattern.b5d7542a.png";